module.exports = __webpack_public_path__ + "static/img/platform.2f82c8f5.svg";